import { gql } from 'graphql-tag';

export const REFERRAL_CREDITS = gql`
  query referralCreditData {
    referralCredit {
      referralCode
      currency
      balance
      # lastReferrer
      # creditDetail {
      #   category
      #   creditCount
      #   nextExpiryDate
      #   nextExpiryCreditCt
      # }
    }
  }
`;
